var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddCircle = function SvgAddCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.445 18.652A8 8 0 0 1 12 20a8.01 8.01 0 0 1-8-8 8 8 0 1 1 12.445 6.652zm-.946-11.888A6.298 6.298 0 0 0 12 5.702 6.305 6.305 0 0 0 5.702 12 6.298 6.298 0 1 0 15.5 6.764zm-4.52 6.087H8.1a.851.851 0 0 1 0-1.702h2.878a.17.17 0 0 0 .17-.17V8.1a.851.851 0 0 1 1.702 0v2.879a.17.17 0 0 0 .17.17h2.88a.851.851 0 1 1 0 1.702h-2.878a.17.17 0 0 0-.17.17V15.9a.851.851 0 1 1-1.702 0v-2.878a.17.17 0 0 0-.17-.17z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "add-circle.4608e47032cc92b6f74af72da6d362e3.svg";